// extracted by mini-css-extract-plugin
module.exports = {"RightWrapperPart":"RightWrapperPart_RightWrapperPart__2Ufz7"};